// extracted by mini-css-extract-plugin
export default {"box":"CheckButton_box__2SKo2","hint":"CheckButton_hint__ycOZ7"};